import { createContext } from "react"

export const initialStateContext = {}
const initialDispatchContext = {}

export const IncidentsStateContext = createContext(initialStateContext)
export const IncidentsDispatchContext = createContext(initialDispatchContext)
